import { initialState } from '@store/constants';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

function useItemQuantity(itemId: string) {
    const activityId = useItemActivityId();
    const { orderLines } = useSelector((root: RootState) => root.item[activityId] ?? initialState);

    return orderLines.find((orderLine) => orderLine.shopItemId === itemId)
        ?.quantity || 0;
}

export default useItemQuantity;
